import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation, useNavigate } from 'react-router-dom';
import './App.css';
import { getAuth, logoutGlobal } from './ApiServices/Auth.Service'
import LoginPage from './Screens/LoginPage/LoginPage';
import AuthManger from './Screens/AuthScreens/index';
import MainPage from './MainPage/MainPage';
import EnterpriseAppsDashboard from './Screens/EnterpriseApps';
import EnterpriseVendorDetails from './Screens/EnterpriseApps/EnterpriseVendorDetails';
import LLMReview from './Screens/EnterpriseApps/LLMReview';
import Dashboard from './Screens/Dashboard/Dashboard';
import Review from './Screens/EnterpriseApps/Review/Review';
import Account from './Screens/Accounts';
import TrustCenterEditor from './Screens/TrustCenterEditor';
import TrustCenter from './TrustCenter/TrustCenter';
import Register from './Screens/Register';
import Profile from './Screens/Profile';
import Settings from './Screens/Settings';
import ForgotPassword from './Screens/ForgotPassword';
import Peoples from './Screens/Peoples';
import Outbound from './Screens/Outbound';
import TermsOfService from './Screens/TermsOfService';
import PrivacyPolicy from './Screens/PrivacyPolicy';
import NDA from './Screens/NDA';
import AddNDA from './Screens/NDA/addNDA';
import AiQuestionnaireAutoComplete from './Screens/AiQuestionnaireAutoComplete';
import TokenCheck from './Helper/TokenCheck';
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from "./Redux/Store";
import { useSelector, useDispatch } from 'react-redux';
import { checkSpecialDomain } from './Redux/Actions/SagaAction';
import Signup from './Screens/Signup';
import SignUpConfirmation from './Screens/SignUpConfirmation';
import OutboundReview from './Screens/Outbound/OutboundReview';
import InboundReview from './Screens/Inbound/InboundReview';

const isAuthenticated = () => {
  const isAuth = localStorage.getItem(`${process.env.REACT_APP_STORAGE_KEY}/token`) ? true : false;
  return isAuth;
};

const PrivateRoute: React.FC<{ element: React.ElementType }> = ({ element: Element }) => {
  return isAuthenticated() ? <Element /> : <Navigate to="/login" replace />;
};

const INBOUND_REVIEW_URL_REGEX = /^\/inbound\/review\/[^/]+/;

/** When inbound user has no id, use returnUrl or lastInboundReviewUrl so id is always populated */
const InboundRedirectFallback = () => {
  const navigate = useNavigate();
  React.useEffect(() => {
    const storageKey = `${process.env.REACT_APP_STORAGE_KEY}/returnUrl`;
    const lastUrlKey = `${process.env.REACT_APP_STORAGE_KEY}/lastInboundReviewUrl`;
    const returnUrl = localStorage.getItem(storageKey);
    const lastInboundUrl = localStorage.getItem(lastUrlKey);
    const target =
      (returnUrl && INBOUND_REVIEW_URL_REGEX.test(returnUrl) && returnUrl) ||
      (lastInboundUrl && INBOUND_REVIEW_URL_REGEX.test(lastInboundUrl) && lastInboundUrl);
    if (target) {
      if (returnUrl === target) localStorage.removeItem(storageKey);
      navigate(target, { replace: true });
    } else {
      navigate('/login', { replace: true });
    }
  }, [navigate]);
  return null;
};

export const AppRoutes = () => {
  const authData: any = useSelector((state: any) => state.AppReducer.authData);
  const isSpecialDomain: string = useSelector((state: any) => state.AppReducer.isSpecialDomain);
  const dispatch = useDispatch();
  const location = useLocation();

  React.useEffect(() => {
    checkRedux();
  }, []);

  React.useEffect(() => {
    
    if (isSpecialDomain == 'TRUE') {
      console.log('isSpecialDomain', '=>', isSpecialDomain);
    }
  }, [isSpecialDomain])

  const checkRedux = () => {
    if (localStorage.getItem('appVersion') && process.env.REACT_APP_VERSION != localStorage.getItem('appVersion')) {
      logoutGlobal();
    } else {
      localStorage.setItem('appVersion', `${process.env.REACT_APP_VERSION}`);
    }

    // dispatch(checkSpecialDomain('versatilecommerce.targheesecstage3221.com'))
    dispatch(checkSpecialDomain(window.location.hostname))
  }


  /**@CHECK_SPECIAL_DOMAIN :Render a loading state while checking the domain */
  if (isSpecialDomain === "") {
    return <div style={{ height: '100vh', width: '100%', color: '#FFF', zIndex: 999, fontSize: 16, backgroundColor: '#FFF' }}></div>;
  }

  if (authData?.inboundUser) {
    const currentPath = location.pathname;
    const idMatch = currentPath.match(/\/inbound\/review\/([^\/]+)/);
    const id = idMatch ? idMatch[1] : '';

    if (!id) {
      return (
        <Routes>
          <Route path="*" element={<InboundRedirectFallback />} />
        </Routes>
      );
    }

    return (
      <Routes>
        <Route path="/inbound/review/:id" element={<InboundReview />} />
        <Route path="*" element={<Navigate to={`/inbound/review/${id}`} replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      {isSpecialDomain != 'TRUE' ? (

        <>
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/" element={<PrivateRoute element={EnterpriseAppsDashboard} />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/forgot-password/:emailValue" element={<ForgotPassword />} />
        <Route path="/register" element={<Signup />} /> // this is for waitlist
        <Route path="/signup" element={<Register />} /> // this provisions accounts
        <Route path="/provision" element={<AuthManger />} />
        <Route path="/signupconfirmation" element={<SignUpConfirmation />} /> 
        <Route path="/trust-center" element={<PrivateRoute element={TrustCenter} />} />
        {/* email params route */}
        <Route path="/trust-center/:userId" element={<PrivateRoute element={TrustCenter} />} />
        <Route path="/main" element={<PrivateRoute element={MainPage} />} />
        <Route path="/enterprise" element={<PrivateRoute element={EnterpriseAppsDashboard} />} />
        <Route path="/enterprise-vendor-details" element={<PrivateRoute element={EnterpriseVendorDetails} />} />
        <Route path="/enterprise-apps/review/:questionnareId" element={<PrivateRoute element={Review} />} /> 
        <Route path="/enterprise-review/:questionnareId" element={<PrivateRoute element={Review} />} /> 
        <Route path="/dashboard" element={<PrivateRoute element={Dashboard} />} />
        <Route path="/account" element={<PrivateRoute element={Account} />} />
        <Route path="/trust-center-editor" element={<PrivateRoute element={TrustCenterEditor} />} />
        <Route path="/profile" element={<PrivateRoute element={Profile} />} />
        <Route path="/settings" element={<PrivateRoute element={Settings} />} />
        {/* <Route path="/llm-question-review" element={<PrivateRoute element={LLMReview} />} /> */}
        <Route path="/ai-questionnaire-auto-complete" element={<PrivateRoute element={AiQuestionnaireAutoComplete} />} />
        <Route path="/NDA/addNDA" element={<PrivateRoute element={AddNDA} />} />
        <Route path="/inbound/review/:id" element={<InboundReview />} />
        <Route path="/outbound" element={<PrivateRoute element={Outbound} />} />
        <Route path="/outbound/review/:id" element={<PrivateRoute element={OutboundReview} />} />
        {authData?.admin ? (
            <>
                <Route path="/people" element={<PrivateRoute element={Peoples} />} />
                
            </>
        ) : null}
        <Route path="*" element={<Navigate to="/login" replace />} />
        </>
        
      ) : (
        <>
        <Route path="/" element={<TrustCenter />} />
        <Route path="/:userId" element={<TrustCenter />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/NDA" element={<NDA />} />
        <Route path="*" element={<TrustCenter />} />
      </>
      
      )}
    </Routes>
  )
}

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router basename="/">
          <TokenCheck>
            <AppRoutes />
          </TokenCheck>
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
